import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RCustomEmojisDirty = t.type({
  route: t.string,
  shortcodes: t.readonlyArray(t.string, 'customEmojis'),
});

/*
 * Type.
 */

export interface CustomEmojisModel extends t.TypeOf<typeof RCustomEmojisDirty> {}
export const RCustomEmojis = t.clean(RCustomEmojisDirty);

/*
 * IO methods.
 */

export function parseCustomEmojis(src: any): CustomEmojisModel {
  return src;
}

/*
 * API type.
 */

export const ApiCustomEmojis = makeApiType('customEmojis', RCustomEmojis, parseCustomEmojis);
